import { render, staticRenderFns } from "./IntakeForm.vue?vue&type=template&id=4ad2da46&scoped=true&"
import script from "./IntakeForm.vue?vue&type=script&lang=ts&"
export * from "./IntakeForm.vue?vue&type=script&lang=ts&"
import style0 from "./IntakeForm.vue?vue&type=style&index=0&id=4ad2da46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad2da46",
  null
  
)

export default component.exports